const commissionDetail = () =>
  import('@/views/main/commission/detail/detail.vue')
export default {
  path: '/main/commission/detail',
  name: 'commissionDetail',
  component: commissionDetail,
  children: []
}
